import { render } from "./FlowPanel.vue?vue&type=template&id=63e386d5"
import script from "./FlowPanel.vue?vue&type=script&lang=js"
export * from "./FlowPanel.vue?vue&type=script&lang=js"
script.render = render

export default script